// import * as PIXI from 'pixi.js';
// import FontFaceObserver from 'fontfaceobserver';
// import ResizeObserver from 'resize-observer-polyfill';
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";

(function(){

  const canvas = document.getElementById('home-canvas');

  if(!canvas) return this;

  const app = new PIXI.Application({
    width: window.outerWidth,
    height: window.outerWidth * 9 / 16,
    backgroundColor: 0xb01928,
    transparent: false,
    antialias: true
  });
  canvas.appendChild(app.view);

  const resources = [
    '/movie/com_01.mp4',
    '/movie/com_02.mp4',
    '/movie/com_03.mp4',
    '/movie/com_04.mp4',
    '/movie/com_05.mp4',
    '/movie/com_06.mp4',
    '/movie/com_07.mp4',
  ];

  console.log('PIXI morirobo cover animation v1.2.7');

  loader(PIXI,app,resources);

})();

function loader(PIXI,app,resources){
  let textures = [];
  resources.forEach(function(value) {
    const texture = PIXI.Texture.from(value);
    const video = texture.baseTexture.resource.source;
    video.loop = true;
    video.muted = "muted";
    video.addEventListener('canplaythrough', function(e){
      textures.push(texture);
      this.play();
      // console.log(":: progress: " + Math.floor(loader.progress) + "% ::");
      if(resources.length === textures.length){
        document.body.classList.add('loaded-home-canvas');
        main(PIXI,app,textures);
      }
    }, {
      once: true
    });
  });
}

function main(PIXI,app,textures){

  const rotation_container = new PIXI.Container();
  app.stage.addChild(rotation_container);

  rotation_container.rotation = -0.05;
  rotation_container.x = -app.view.width / 10;
  rotation_container.scale.x = 0.8;
  rotation_container.scale.y = 0.8;

  function pickArrayRandom(array, num) {
    var a = array;
    var t = [];
    var r = [];
    var l = a.length;
    var n = num < l ? num : l;
    while (n-- > 0) {
      var i = Math.random() * l | 0;
      r[n] = t[i] || a[i];
      --l;
      t[i] = t[l] || a[l];
    }
    return r;
  }

  function makeContainer(size, offset_x = 0, offset_y = 0){
    const container = new PIXI.Container();
    container.x = app.view.width / 4 * offset_x;
    container.y = offset_y;
    rotation_container.addChild(container);
    let pickup_num;
    switch (size) {
      case 1: pickup_num = 6; break;
      case 2: pickup_num = 3; break;
      case 3: pickup_num = 2; break;
      default:
    }
    makeLine(container, size, pickup_num, offset_x, offset_y);
  }

  function addTimeline(target){
    target.timeline.add(
      TweenMax.to(target, 2, {
        y: target.y - target.width,
        ease: Expo.easeInOut,
        force3D: true
      })
    );
  }
  function makeLine(target_container, size, pickup_num, offset_x = 0, offset_y = 0){
    target_container.timeline = new TimelineLite({
      onComplete: function(){
        if(target_container.y < target_container.width-target_container.height){
          makeContainer(size, offset_x, target_container.height);
          target_container.destroy();
          return;
        }else{
          addTimeline(target_container)
        }
      }
    });
    let firstarray = pickArrayRandom(textures, pickup_num);
    firstarray.forEach(function(texture, index){
      makeSprite(target_container, texture, index, size);
    });
    addTimeline(target_container);
    if(offset_y === 0){
      makeContainer(size, offset_x, target_container.height);
    }
  }
  function makeSprite(target, texture, index, size){
    const videoSprite = new PIXI.Sprite(texture);
    videoSprite.width = app.view.width / 4 * size;
    videoSprite.height = videoSprite.width;
    videoSprite.y = videoSprite.width * index;
    target.addChild(videoSprite);
  }

  makeContainer(2);
  makeContainer(1, 2);
  // makeContainer(2, 3);
  // makeContainer(1, 5);
  makeContainer(3, 3);

}//end main
